import React from 'react';
import { connect } from 'react-redux';
import { DBDecimalFieldObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class ObservationCircumferenceMCP extends React.Component {

    render() {
        return (
            <div>
                <div className={styles.row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Circumference - MCP' />
                    <label className={styles.label}>MCP</label>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Thumb</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRMCPTHUMBR'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRMCPTHUMBL'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Index</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRMCPINDEXR'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRMCPINDEXL'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Middle</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRMCPMIDDLER'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRMCPMIDDLEL'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Ring</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRMCPRINGR'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRMCPRINGL'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Small</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRMCPSMALLR'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRMCPSMALLL'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                </div>

            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        oono: oono,
        flagged:
            (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRMCPTHUMBR !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRMCPTHUMBR !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRMCPTHUMBL !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRMCPTHUMBL !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRMCPINDEXR !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRMCPINDEXR !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRMCPINDEXL !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRMCPINDEXL !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRMCPMIDDLER !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRMCPMIDDLER !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRMCPMIDDLEL !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRMCPMIDDLEL !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRMCPRINGR !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRMCPRINGR !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRMCPRINGL !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRMCPRINGL !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRMCPSMALLR !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRMCPSMALLR !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRMCPSMALLL !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRMCPSMALLL !== null)
                ? true : false
    };
}

const connectedObservationCircumferenceMCP = connect(mapStateToProps)(ObservationCircumferenceMCP);
export { connectedObservationCircumferenceMCP as ObservationCircumferenceMCP };


